import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CalendarCheckIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M16 1a1 1 0 011 1v1h2a3 3 0 013 3v2.966l.005.084c0 .029 0 .056-.003.084L22 20a3 3 0 01-3 3H5a3 3 0 01-3-3V6a3 3 0 013-3h2V2a1 1 0 01.883-.993L8 1a1 1 0 011 1v1h6V2a1 1 0 01.883-.993zm4 9.05H4V20a1 1 0 001 1h14a1 1 0 001-1v-9.95zm-5.2 2.25c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-5 5c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3zM7 5H5a1 1 0 00-1 1v2.05h16V6a1 1 0 00-1-1h-2v1a1 1 0 01-.883.993L16 7a1 1 0 01-1-1V5H9v1a1 1 0 01-.883.993L8 7a1 1 0 01-1-1V5z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
CalendarCheckIcon.isCarinaIcon = true;
export default CalendarCheckIcon;
